import {Component, Input} from '@angular/core';
import {TaakType} from '../../../dienst/taak';
import {ClientDienst} from '../../client-dienst';
import {Dienst} from '../../../dienst/dienst';

@Component({
    selector: 'zah-taak-type',
    templateUrl: './client-taak-type.component.html',
    styleUrls: ['./client-taak-type.component.scss'],
    standalone: false
})
export class ClientTaakTypeComponent {

  @Input()
  expanded = false;
  @Input()
  taakType: TaakType;
  @Input()
  clientDienst: ClientDienst;
  @Input()
  dienst: Dienst;

  toggleExpand(): void {
    this.expanded = !this.expanded;
  }
}
